export function trendClass(value: Number) {
  return {
    flat: value === 0 || !value,
    pos: value > 0,
    neg: value < 0,
  };
}

export function trendIcon(value: Number) {
  return {
    fa: true,
    'fa-arrow-circle-up': value > 0,
    'fa-arrow-circle-down': value < 0,
    'fa-arrow-circle-right': value === 0 || !value,
  };
}
